/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import { defineMessages } from 'react-intl'

export const translations = defineMessages({
  overview: {
    defaultMessage: 'Overview',
    id: 'global.account.link.account_overview'
  },
  profile: {
    defaultMessage: 'My Data',
    id: 'global.account.link.my_account_data'
  },
  addresses: {
    defaultMessage: 'My Addresses',
    id: 'global.account.link.my_addresses'
  },
  orders: {
    defaultMessage: 'My Orders/Invoices',
    id: 'global.account.link.order_history_invoices'
  },
  payments: {
    defaultMessage: 'My Payment Methods',
    id: 'global.account.link.my_payment_methods'
  },
  wishlist: {
    defaultMessage: 'My Wishlist',
    id: 'global.account.link.wishlist'
  },
  data_sharing: {
    defaultMessage: 'My Data Sharing',
    id: 'global.account.link.my_data_sharing'
  },
  machines: {
    defaultMessage: 'My Machines',
    id: 'global.account.link.my_machines'
  }
})

/**
 * Note: The items order in the array also determines the order of the links display on the menu!
 */
export const navLinks = [
  {
    name: 'overview',
    path: '/account'
  },
  {
    name: 'orders',
    path: '/account/orders'
  },
  {
    name: 'wishlist',
    path: '/account/wishlist'
  },
  {
    name: 'profile',
    path: '/account/my-data'
  },
  {
    name: 'addresses',
    path: '/account/addresses'
  },
  {
    name: 'payments',
    path: '/account/payment-methods'
  },
  {
    name: 'data_sharing',
    path: '/account/data-sharing'
  },
  {
    name: 'machines',
    path: '/account/my-machines'
  }
]
